$(function() {
  $(document).on('click','.btn-more', function() {
    $(this).addClass('d-none').next('.more-to-see').addClass('show');
  });

  $(document).on('click','.btn-chapo-more', function() {
    $(this).addClass('d-none').next('.chapo-more').addClass('show');
  });

  $(document).on('click','.btn-chapo-less', function() {
    $('.chapo-more').removeClass('show');
    $('.btn-chapo-more').removeClass('d-none');
  });
});
